export abstract class ComponentLoaderService {

  abstract setRootViewContainerRef(viewContainerRef): void;
  abstract loadComponentDynamically();
}



// WEBPACK FOOTER //
// ./src/app/common/component-loader.service.ts